import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faSquareFacebook, faSquareInstagram, faSquareXTwitter, faSquareYoutube } from '@fortawesome/free-brands-svg-icons'
import Reveal from '../../../components/reveal'
import Addresses from '../../../components/site/Addresses'
import { about, sections, addresses } from '../../../content/site'

// About page, on the new design system (Task 7). This page has no counterpart in the
// source project - its content (a signed opening statement + five plain-prose essays, no
// lists) rules out the card-grid/data-driven components the rest of the site uses, so it
// is built directly here rather than as reusable src/components/site/ pieces, from the
// primitives .hero-section/.section/.container/.section-eyebrow/.section-title already
// provide. New CSS lives under the ABOUT banner in src/css/site/site.css.
//
// Replaces the six old per-section folders (hero, craftsmanship, innovative, personalized,
// quality, experience) - all deleted, their content moved verbatim into `about` in
// src/content/site.js. Also drops the `Labinfo` import from ../home/labs (the old
// index.jsx:7) in favour of <Addresses/>, the shared component built in Task 5 - per the
// task-7 brief this makes src/pages/public/home/labs/ unused, so it is deleted too.
const SOCIAL_ICON = {
    facebook: faSquareFacebook,
    x: faSquareXTwitter,
    linkedin: faLinkedin,
    instagram: faSquareInstagram,
    youtube: faSquareYoutube
};

const Index = () => {
    return (
        <>
            <section className="hero-section about-hero">
                <div className="hero about-hero-inner -reading">
                    <div className="hero-eyebrow">{about.hero.eyebrow}</div>
                    <h1>{about.hero.title}</h1>
                    <p className="hero-desc about-hero-desc">{about.hero.paragraph}</p>

                    {/* The founder's attribution as a sign-off on the statement above, not a
                        marketing block - the one thing this page has that a competitor's
                        About page does not. */}
                    <div className="about-hero-signature">
                        <div className="about-hero-signature-name">{about.hero.founderName}</div>
                        <div className="about-hero-signature-role">{about.hero.founderRole}</div>
                    </div>

                    <div className="hero-actions about-hero-actions">
                        <Link className="btn-lg" to="/contant">{about.hero.primaryCta}</Link>
                        <p className="about-hero-login">
                            {about.hero.secondaryCtaLead} <Link to="/login">{about.hero.secondaryCtaLabel}</Link>
                        </p>
                    </div>

                    <div className="about-hero-social">
                        {about.hero.social.map((s) => (
                            <a
                                key={s.href}
                                className="footer-social-icon"
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={s.label}
                            >
                                <FontAwesomeIcon icon={SOCIAL_ICON[s.icon]} />
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* Five parallel claims, not a sequence - no 01/02/03 numbering. Alternating
                white/surface backgrounds are the only structural device; no cards, no icons. */}
            {about.essays.map((essay, i) => (
                <Reveal key={essay.key}>
                    <section className={`section about-essay${i % 2 === 1 ? ' is-alt' : ''}`}>
                        <div className="container">
                            <h2 className="section-title">{essay.title}</h2>
                            <p className="section-sub about-essay-p">{essay.paragraph}</p>
                        </div>
                    </section>
                </Reveal>
            ))}

            <Reveal><Addresses section={sections.addresses} addresses={addresses} /></Reveal>
        </>
    )
}

export default Index
